<template>
  <div v-html="number" />
</template>

<script>
export default {
  name: 'Counter',

  props: {
    number: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  position: relative;
  display: inline-block;
  font-size: rem(14px);
  color: $color-text;
  transform: translate3d(0%, 25%, 0);

  @include mq(ipadP) {
    font-size: rem(16px);
    transform: translate3d(0%, 50%, 0);

    // @at-root [js-page="home"] & {
    //   transform: translate3d(-100%, 50%, 0);
    // }
  }

  &::after {
    content: '.';
    margin-left: 5px;
  }
}
</style>
